import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  constructor(private http: HttpClient) {}

  //RegistrationStep
  getRegistrationSteps(query: {
    name?: string;
    type?: 'Client' | 'Vendor' | 'CompanyVendor';
    RegistrationProgress?: string;
  }): Observable<any> {
    return this.http.get('/api/v2/registrationStep', { params: query });
  }
}
